import debug from 'debug'
import API from '@/api/client'

const STORAGE_KEY = 'stunservers'

const dbg = debug('SIPUA:STUN:')

export default {
  async getImpl (url) {
    let servers = ''
    try {
      const res = await API.GET(url)
      servers = res.data?.server
    } catch (err) {
      dbg('Error getting stun servers from url %s: %o', url, err)
    }

    if (!servers) {
      // we could not find anything from remote api server, check if we have something in our local storage
      servers = localStorage.getItem(STORAGE_KEY)

      if (servers) {
        dbg('Found STUN servers from local storage, pushing to remote api')
        this.set(servers)
      }
    }
    dbg('Returning stun servers list %s', servers)
    return servers
  },

  async get () {
    const servers = await this.getImpl(API.url('stun_servers'))
    return servers
  },

  async set (server) {
    try {
      await API.PUT(API.url('stun_servers'), { server })
    } catch (err) {
      dbg('Error setting stun servers: %o', err)
    }
  },

  async getResolved () {
    const servers = await this.getImpl(API.url('stun_servers/resolved'))
    return servers
  }
}
